import { render, staticRenderFns } from "./TaksitAnaBilgilerForm.vue?vue&type=template&id=2885947c&scoped=true"
import script from "./TaksitAnaBilgilerForm.vue?vue&type=script&lang=ts"
export * from "./TaksitAnaBilgilerForm.vue?vue&type=script&lang=ts"
import style0 from "./TaksitAnaBilgilerForm.vue?vue&type=style&index=0&id=2885947c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2885947c",
  null
  
)

export default component.exports